<template>
    <div
        v-if="isAdFinalScreenVisible"
        :class="$style.wrapper"
        @click="adDisabledStore.closeNoAdFinalScreen"
    >
        <img
            :class="$style.icon"
            :src="Icon"
            alt=""
        />
        <Typography
            type="label"
            size="s"
            :class="$style.title"
        >
            <!-- eslint-disable vue/no-v-html -->
            <span v-html="$tr('noAdFinalScreen.title', remainingDaysWithoutAd)" />
            <!-- eslint-enable vue/no-v-html -->
        </Typography>
        <Button
            type="submit"
            color="lime"
            interfaceTarget="no-ad-final-screen-button"
            size="l"
            :class="$style.button_override"
            :label="$tr('noAdFinalScreen.button')"
            @click="adDisabledStore.closeNoAdFinalScreen"
        />
    </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import Button from '@/components/Buttons/Button.vue'
import Typography from '@/components/Typography.vue'
import { useAdDisabledStore } from '@/store/ad-disabled-store'

import Icon from './images/face.webp'

const adDisabledStore = useAdDisabledStore()
const { isAdFinalScreenVisible, remainingMsWithoutAd } = storeToRefs(adDisabledStore)
// here set only days
const remainingDaysWithoutAd = computed(() => Math.ceil(remainingMsWithoutAd.value / (1000 * 60 * 60 * 24)))
</script>

<style module>
.wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 16px;
    background: linear-gradient(rgb(var(--dominant-rgb, 99, 50, 161)) 10%, #1d1c26 100%) no-repeat;
    gap: 20px;
}

.icon {
    width: 130px;
    height: 130px;
}

.title {
    text-align: center;
}

.button_override {
    width: 320px;
    max-width: 80%;
}
</style>
